var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransporteTramWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6E6259",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M10.28 3.92l.97-1.97h4.179V0H2.57v1.95H8.68L7.7 3.92C3.677 4.042 0 4.854 0 8.45v10.972c0 1.879 1.524 3.451 3.33 3.868l-2.044 2.06V26h2.867l2.571-2.6h4.847l2.572 2.6h2.571v-.65l-1.928-1.95h-.103c2.173 0 3.317-1.787 3.317-3.978V8.45c0-3.634-3.356-4.42-7.72-4.53zM9 21.45c-1.067 0-1.929-.871-1.929-1.95S7.933 17.55 9 17.55c1.067 0 1.929.871 1.929 1.95S10.067 21.45 9 21.45zm6.429-5.85H2.57V9.1H15.43v6.5z",
    transform: "translate(5 1)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransporteTramWhite);
export default __webpack_public_path__ + "static/media/transporte-tram-white.144d8a57.svg";
export { ForwardRef as ReactComponent };